import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PrefillDataEntry {
  clientPolicyApplicationId: string;
  formId: string;
  clientId: string;
  prefillData: PrefillData[];
  citations: PrefillCitations[];
  status: string;
  error: string | null;
}

export interface PolicyApplicationPrefillState {
  entries: PrefillDataEntry[];
}

const initialState: PolicyApplicationPrefillState = {
  entries: [],
};

const prefillDataSlice = createSlice({
  name: 'policyApplicationPrefill',
  initialState,
  reducers: {
    populatePrefillData(state, action: PayloadAction<PrefillDataEntry>) {
      const { clientId, clientPolicyApplicationId, formId, prefillData, citations } =
        action.payload;

      const existingIndex = state.entries.findIndex(
        entry =>
          entry.clientId === clientId &&
          entry.clientPolicyApplicationId === clientPolicyApplicationId &&
          entry.formId === formId,
      );
      if (existingIndex !== -1) {
        state.entries[existingIndex] = {
          ...state.entries[existingIndex],
          prefillData,
          citations,
        };
      } else {
        state.entries.push({
          clientId,
          clientPolicyApplicationId,
          formId,
          prefillData,
          citations,
          status: 'populated',
          error: null,
        });
      }
    },
    removePrefillData: (
      state,
      action: PayloadAction<{
        clientId: string;
        clientPolicyApplicationId: string;
        formId: string;
      }>,
    ) => {
      const { clientId, clientPolicyApplicationId, formId } = action.payload;
      state.entries = state.entries.filter(
        entry =>
          !(
            entry.clientId === clientId &&
            entry.clientPolicyApplicationId === clientPolicyApplicationId &&
            entry.formId === formId
          ),
      );
    },
    resetPrefillDataState: state => (state = initialState),
  },
});

export const { populatePrefillData, removePrefillData, resetPrefillDataState } =
  prefillDataSlice.actions;

export const policyApplicationPrefillReducer = prefillDataSlice.reducer;
